(function($) {
    gsap.registerPlugin(ScrollTrigger);
    
    // gsap.to(".index-banner", {
    //   y: -200,
    //   ease: "none",
    //   scrollTrigger: {
    //     trigger: ".index-banner-holder",
    //     start: "bottom bottom", // the default values
    //     end: "bottom top",
    //     scrub: true,
    //   }, 
    // });
    gsap.to(".index-project-content .wave1", {
      backgroundPosition: "-200% 0",
      ease: "none",
      scrollTrigger: {
        trigger: ".index-project",
        // start: "top bottom", // the default values
        // end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true,
      }, 
    });
    gsap.to(".index-project-content .wave2", {
      backgroundPosition: "200% 0",
      ease: "none",
      scrollTrigger: {
        trigger: ".index-project",
        // start: "top bottom", // the default values
        // end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true,
      }, 
    });

    var indexBannerBg = $('.index-banner-bg').slick({
        fade: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 1500,
        dots: true,
        arrows: false,
        swipe: false,
        pauseOnHover: false,
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      // console.log(slick, nextSlide);
      if ($(slick.$slides[currentSlide]).find('video').length) {
        $(slick.$slides[currentSlide]).find('video').trigger('pause');
      }
      if ($(slick.$slides[nextSlide]).find('video').length) {
        // slick.pause()
        // $(slick.$slides[nextSlide]).find('video').on('ended', function(){
        //   slick.next()
        // });
        $(slick.$slides[nextSlide]).find('video').trigger('play');
      } else {
        // slick.play()
      }
    });

    $('.js-play-banner').on('click', function(e) {
      $('body').addClass('landing-hide');
      if ($(indexBannerBg.slick('getSlick').$slides[0]).find('video').length) {
        // indexBannerBg.slick('slickPause')
        // $(indexBannerBg.slick('getSlick').$slides[0]).find('video').on('ended', function(){
        //   indexBannerBg.slick('slickNext');
        // });
        $(indexBannerBg.slick('getSlick').$slides[0]).find('video').trigger('play');
      } else {
        // indexBannerBg.slick('slickPlay')
      }
    });

    $('.index-banner-txt').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1500,
        dots: false,
        arrows: false,
        swipe: false,
        pauseOnHover: false,
    });
    $('.index-case-slider').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1500,
        dots: true,
        arrows: false,
        pauseOnHover: true,
    });
    $('.index-project-slider').slick({
      arrows: false,
      dots: false,
      slidesPerRow: 3,
      rows: 2,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesPerRow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesPerRow: 1,
            rows: 1,
          }
        }
      ]
    });
    var openPhotoSwipe = function(url) {
      $.get(url, {},
        function(response){
          var pswpElement = document.querySelectorAll('.pswp')[0];

          // build items array
          var items = $.parseJSON(response);

          var thumbsHTML = '<ul class="list">';
          $.each(items, function(key, item) {
            thumbsHTML += '<li'+(key==0?' class="active"':'')+'>';
            thumbsHTML += '<div class="img" style="background-image: url(\''+item.thumb+'\');"></div>';
            thumbsHTML += '</li>';
          })
          thumbsHTML += '</ul>';
          $('.pswp__thumbs').html(thumbsHTML).show();
          $('.pswp__button--thumbs').show();

          // define options (if needed)
          var options = {
            // history & focus options are disabled on CodePen
            history: false,
            focus: false,
            shareEl: false,

            showAnimationDuration: 0,
            hideAnimationDuration: 0,
          };

          var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
          $('body').addClass('pswp__thumbs--open');
          gallery.init();
          $(document).on('click', '.pswp__thumbs .img', function(event) {
            gallery.goTo($(".pswp__thumbs li").index($(this).parent()));
          }).on('click', '.pswp__button--thumbs', function(event) {
            $('body').toggleClass('pswp__thumbs--open');
            gallery.applyZoomPan(gallery.getZoomLevel(), ($(gallery.container).width()-gallery.currItem.w*gallery.getZoomLevel())/2 , ($(gallery.container).height()-gallery.currItem.h*gallery.getZoomLevel())/2);
            gallery.updateSize(true);
            return false
          });
          gallery.listen('close', function () {
            $('body').removeClass('pswp__thumbs--open');
          });
          gallery.listen('afterChange', function() {
            var ind = gallery.getCurrentIndex();
            $('.pswp__thumbs li').eq(ind).addClass('active');
            $('.pswp__thumbs li').eq(ind).siblings().removeClass('active');
          });
        }
      ).fail(function(response) {
        console.log(response);
      });
    };
    $('.index-project-slider').on('click', '.open-detail', function(event) {
      openPhotoSwipe($(this).attr('href'))
      return false;
    });
    $('.index-banner').on('click', '.bt-scroll', function(e) {
        var t = $(this).attr('href');
        $('html,body').animate({
            scrollTop: $(t).offset().top
        }, 400);
        return false;
    });
})($);